// extracted by mini-css-extract-plugin
module.exports = {"avatar":"kgoZhz","container":"_1M_NcW","linkedin":"H-Np95"};